export class GetPatientDetailsRequestModel {
  strLink: string;
}
